import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { trpc } from "../api/trpc";

interface AdminRouteProps {
  children: ReactNode;
}

/**
 * Client-side role gate for ADMIN routes.
 * Must be nested inside ProtectedRoute (auth is handled there).
 * This is a UX gate only — every mutation is gated server-side.
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const { data: me, isLoading } = trpc.auth.getMe.useQuery();

  if (isLoading) {
    return (
      <div className="h-screen w-full bg-[var(--color-bg-page)] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500" />
          <p className="text-sm text-[var(--color-text-secondary)]">Loading...</p>
        </div>
      </div>
    );
  }

  if (me?.role !== "ADMIN") {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
